(function () {
  function initSearchDrawer() {
    const drawer = document.getElementById('search-drawer');
    const backdrop = document.getElementById('search-backdrop');
    const input = document.getElementById('site-search-input');
    const closeBtn =
      document.getElementById('search-close') ||
      document.querySelector('[data-search-close], .search-close');

    const siteChrome =
      document.getElementById('site-chrome') ||
      document.querySelector('.site-chrome') ||
      document.querySelector('.site-header') ||
      document.querySelector('header');

    // Horizon theme: button.search-open inside <search-button>
    const openButtons = Array.from(
      document.querySelectorAll(
        '#search-open, [data-search-open], .search-open, search-button button'
      )
    ).filter(function (btn, index, list) {
      return list.indexOf(btn) === index;
    });

    if (!drawer || !backdrop || openButtons.length === 0) {
      return;
    }

    function setChromeHeight() {
      if (!siteChrome) return;
      document.documentElement.style.setProperty(
        '--site-chrome-height',
        siteChrome.offsetHeight + 'px'
      );
    }

    function openSearch(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      setChromeHeight();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('search-is-open');

      if (closeBtn) {
        closeBtn.hidden = false;
      }

      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 120);
      }
    }

    function closeSearch(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-is-open');

      if (closeBtn) {
        closeBtn.hidden = true;
      }
    }

    setChromeHeight();
    window.addEventListener('resize', setChromeHeight);

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeSearch);
    }

    backdrop.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeSearch();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchDrawer);
  } else {
    initSearchDrawer();
  }
})();
